'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

exports.setInternalFormItem = setInternalFormItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('./utils');

var _mobxReact = require('mobx-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormItem = null;

/**
 * set the internal FormItem component that be used in rc-mobx-form
 * @param fi FormItem Component
 */
function setInternalFormItem(fi) {
  FormItem = fi;
}

var MobxFormItem = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(MobxFormItem, _React$Component);

  function MobxFormItem() {
    _classCallCheck(this, MobxFormItem);

    return _possibleConstructorReturn(this, (MobxFormItem.__proto__ || Object.getPrototypeOf(MobxFormItem)).apply(this, arguments));
  }

  _createClass(MobxFormItem, [{
    key: 'render',
    value: function render() {
      if (!FormItem) throw new Error('You must set the FormItem by `useFormItem` function in entry file.');

      var fieldOption = void 0;
      var children = _react2.default.Children.toArray(this.props.children);
      // get the first form component that bind props
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          var childFieldOption = this.context.form.fieldOptions[child.props && child.props['data-field-name']];
          if (childFieldOption && (typeof childFieldOption === 'undefined' ? 'undefined' : _typeof(childFieldOption)) === 'object') {
            fieldOption = childFieldOption;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var appendProps = {};
      if (fieldOption) {
        var name = fieldOption.name;

        // display default label ?
        if (this.context.displayDefaultLabel && this.props.label === undefined) {
          appendProps.label = name;
        }

        // set validate status
        if (!this.props.disabledValidate) {
          var err = this.context.form.errors.get(name);
          if (err) {
            appendProps.validateStatus = err.length > 0 ? 'error' : 'success';
          }
          appendProps.required = (0, _utils.checkIsRequired)(fieldOption.rules);
          appendProps.help = appendProps.validateStatus === 'error' && err.map(function (_ref) {
            var message = _ref.message;
            return message;
          }).join(' ');
        }
      }

      return _react2.default.createElement(FormItem, _extends({}, this.context.defaultItemProps, appendProps, this.props));
    }
  }]);

  return MobxFormItem;
}(_react2.default.Component), _class2.propTypes = {
  disabledValidate: _react.PropTypes.bool }, _class2.defaultProps = {
  disabledValidate: false
}, _class2.contextTypes = {
  form: _react.PropTypes.object, // the form object
  defaultItemProps: _react.PropTypes.object, // global default FormItem props
  displayDefaultLabel: _react.PropTypes.bool }, _temp)) || _class;

exports.default = MobxFormItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-mobx-form/lib/FormItem.js
// module id = 681
// module chunks = 0